import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Button } from '../../atoms';
export function DateRangeItem({ active = false, id, label, onPress }) {
    // Handlers
    const handlePress = useCallback(() => {
        onPress(id);
    }, [onPress, id]);
    // Render
    return (_jsx(Button, { label: label, variant: active ? 'secondary' : 'tertiary', onPress: handlePress, size: "sm" }));
}
